import * as React from "react";
import {
  Text,
  TextInput,
  View,
  StyleSheet,
  Image,
  TouchableWithoutFeedback,
  TouchableOpacity,
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import { modifyPartner } from "../../redux/actions/PartnerActions";
import GlobalStyles from "../../components/GlobalStyles";
import axios from "axios";
import { useSelector } from "react-redux";
import { user_unset_firstrun } from "../../redux/actions/UserActions";
import { user_logout } from "../../redux/actions/UserActions";
import { Auth } from "aws-amplify";

function goToLinkingAccouts(navigation) {
  // user_unset_firstrun();
  navigation.replace("FirstSignInStartLinking");
}

function goToOnboarding(navigation) {
  navigation.replace("FirstSigninScreen");
}

async function LogoutButton({ navigation }) {
  Auth.signOut().then(() => {
    user_logout();
    navigation.navigate("Welcome");
  });
}

export default function FirstSignInLandingScreen({ route }) {
  const navigation = useNavigation();

  return (
    <View style={GlobalStyles.containerMB}>
      <View style={styles.bodyContainerT}>
        <View style={styles.formContainer}>
          <Text style={styles.textStyleHeaderB}>Welcome</Text>
          <View style={styles.formStyle}>
            <View style={styles.buttonContainerA}>
              <TouchableOpacity
                style={styles.SubmitButtonStyleContinue}
                activeOpacity={0.5}
                onPress={() => goToOnboarding(navigation)}
              >
                <Text style={styles.textStyleButton}>Start my new account</Text>
              </TouchableOpacity>
            </View>
            <Text style={styles.textStyleHeaderC}>Already an Aura member?</Text>
            <Text style={styles.TextStyleBody}>
              If you've signed up with Aura in the past, it's easy to combine
              your 2 accounts.
            </Text>

            <View style={styles.buttonContainer}>
              <TouchableOpacity
                style={styles.SubmitButtonStyleMerge}
                activeOpacity={0.5}
                onPress={() => goToLinkingAccouts(navigation)}
              >
                <Text style={styles.textStyleButton}>Merge my accounts</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
        <View style={styles.buttonContainer}>
          <TouchableOpacity
            style={styles.SubmitButtonStyleLogout}
            activeOpacity={0.5}
            onPress={() => LogoutButton({ navigation })}
          >
            <Text style={styles.TextStyleCenter}>LOGOUT</Text>
            <View style={styles.LinkBarNext}></View>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  bodyContainerT: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
    justifyContent: "center",
  },

  formStyle: {
    flex: 1,
    flexDirection: "column",
    width: "90%",
  },

  buttonContainer: {
    //flexDirection: "column",
    width: "100%",
    //alignContent: "flex-start",
    paddingLeft: 0,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
  },

  buttonContainerLogout: {
    //flexDirection: "column",
    width: "100%",
    //alignContent: "flex-start",
    paddingLeft: 0,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
  },

  buttonContainerA: {
    //flexDirection: "column",
    width: "100%",
    //alignContent: "flex-start",
    paddingLeft: 0,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 60,
  },

  textStyleButton: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
    //backgroundColor: "green"
  },

  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },

  textStyleHeaderB: {
    color: "#ffffff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    paddingLeft: 15,
    paddingRight: 30,
  },

  textStyleHeaderC: {
    color: "#ffffff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 18,
    width: "100%",
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 30,
  },

  TextStyleBody: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 20,
    paddingTop: 10,
  },
  formContainer: {
    alignContent: "center",
    backgroundColor: "#FFC72C",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 55,
    borderTopLeftRadius: 70,
    borderTopRightRadius: 70,
    borderBottomRightRadius: 70,
    paddingBottom: 55,
    minHeight: 450,
    maxWidth: 800,
    alignSelf: "center",
    paddingLeft: 15,
    paddingRight: 15,
  },

  SubmitButtonStyleContinue: {
    //paddingTop: 20,
    // paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    maxHeight: 60,
    minHeight: 60,
    justifyContent: "center",
    marginBottom: 20,
  },

  SubmitButtonStyleMerge: {
    //paddingTop: 20,
    // paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFC72C",
    flex: 1,
    color: "#000000",
    height: 60,
    maxHeight: 60,
    minHeight: 60,
    justifyContent: "center",
    marginBottom: 20,
    borderEndColor: "#000000",
    borderStyle: "solid",
    borderWidth: 1,
  },

  SubmitButtonStyleLogout: {
    //paddingTop: 20,
    // paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    //backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    maxHeight: 60,
    minHeight: 60,
    justifyContent: "center",
    marginBottom: 20,
    paddingTop: 40,
  },

  LinkBarNext: {
    width: 70,
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "center",
    marginTop: 10,
    marginBottom: 0,
  },

  TextStyleCenter: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },

  HbackButtonStyle: {
    marginTop: 0,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },
});
